import { t } from "components/CentralDataMangement/translation/Translation";
import React, { useState, useRef, useEffect } from "react";

interface Option {
  label: string;
  subOptions: string[];
}

interface HoverSelectDropdownProps {
  options: Option[];
  onSelect: (mainOption: string, subOption: string) => void;
  label?:string;
}

const HoverSelectDropdown: React.FC<HoverSelectDropdownProps> = ({
  options,
  onSelect,
  label = t("Select")
  
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState<string | null>(null);

  // Close dropdown when clicked outside
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setHovered(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown multi-level-dropdown" ref={dropdownRef}>
      <button
        className="field-shadow dropdown-toggle form-control form-select"
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        {label}
      </button>

      <ul
        className={`dropdown-menu${isOpen ? " show" : ""}`}
        style={{ minWidth: "100%" }}
      >
        {options.map((option) => (
          <li
            key={option.label}
            className="dropdown-submenu"
            onMouseEnter={() => setHovered(option.label)}
            onMouseLeave={() => setHovered(null)}
            style={{ position: "relative" }}
          >
            <a
              href="#!"
              className="dropdown-item dropdown-toggle"
              onClick={(e) => e.preventDefault()}
            >
              {option.label}
            </a>

            <ul
              className={`dropdown-sub-menu${hovered === option.label ? " show" : ""} position-absolute vacancydropdownOptions`}
            >
              {option.subOptions.map((subOption) => (
                <li key={subOption}>
                  <a
                    href="#!"
                    className="dropdown-item"
                    onClick={(e) => {
                      e.preventDefault();
                      onSelect(option.label, subOption);
                      setIsOpen(false);
                      setHovered(null);
                    }}
                  >
                    {subOption}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HoverSelectDropdown;
